module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "triangle-pics",
    attrs: {
      "id": "triangle-pics"
    }
  }, [_c('div', {
    staticClass: "triangle-pic"
  }, [_c('img', {
    attrs: {
      "src": ("/static/img/banner-0" + _vm.step + ".jpg")
    }
  })])]), _c('div', {
    staticClass: "banner-block"
  }), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-text"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('h1', [_vm._v("前沿社是企业家自我提升的")]), _c('h1', {
    staticClass: "cn"
  }, [_vm._v("「加速器」")])]), _c('div', {
    staticClass: "block-list"
  }, [_c('dl', [_c('dd', [_vm._v("持续输入")]), _c('dd', [_vm._v("刷新认知")]), _c('dd', [_vm._v("创造改变")])]), _c('a', {
    attrs: {
      "href": "/video"
    }
  }, [_vm._v("观看视频"), _c('div', {
    staticClass: "play"
  }, [_c('div', {
    staticClass: "triangle-right"
  })])])]), _c('div', {
    staticClass: "notes"
  }, [_c('p', [_vm._v("让自己成为企业成长的动力而不是瓶颈")]), _c('p', [_vm._v("像那些优秀科技领袖那样引领变革而不是被变革")]), _c('p', [_vm._v("看到更多新可能，突破今天面对的成长极限")])]), _c('div', {
    staticClass: "links"
  }, [_c('a', {
    attrs: {
      "href": "/entry"
    }
  }, [_vm._v("成为会员"), _c('div', {
    staticClass: "triangle-right"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-196eb1f0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Banner.vue
// module id = 191
// module chunks = 1